import React, { useCallback } from 'react';

import { useLanguage } from 'Context/LanguageContext';
import { useDropzone } from 'react-dropzone';
import { styled } from '@mui/material/styles';

const DashedBoxBorder = styled('div')`
	border: dashed 2px #979797;
	min-height: 100px;
	border-radius: 10px;
	padding: 50px 50px;
	cursor: pointer;
`

const DropZoneMainText = styled('p')`
	text-align: center;
	font-size: 18px;
	color: #767D8E;
`

const DropZoneSecondaryText = styled('p')`
	text-align: center;
	font-size: 14px;
	color: #989EAA;
`

// TODO: Set Max size of the files (configurable as a prop)
const TemplateDropZone = ({ uploadFile, multipleFiles }) => {
	const lan = useLanguage();

	const onDrop = useCallback(
		(acceptedFiles) => {
			if (multipleFiles) {
				acceptedFiles.forEach((file) => uploadFile(file));
			} else {
				uploadFile(acceptedFiles[0]);
			}
		},
		[multipleFiles, uploadFile]
	);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

	return (
		<DashedBoxBorder {...getRootProps()}>
			<input {...getInputProps()} />
			{isDragActive ? (
				<DropZoneMainText>{lan.dropFiles}</DropZoneMainText>
			) : (
				<DropZoneMainText>{lan.selectOrDragAndDrop}</DropZoneMainText>
			)}
			<DropZoneSecondaryText>{lan.toUploadToYourAccount}</DropZoneSecondaryText>
		</DashedBoxBorder>
	);
};

export default TemplateDropZone;
